import { render } from "./BackendLayout.vue?vue&type=template&id=12923db0&ts=true"
import script from "./BackendLayout.vue?vue&type=script&lang=ts"
export * from "./BackendLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__